import { useEnabledPaymentMethods } from "checkout-experience/hooks/use-enabled-payment-methods";
import { PaymentType } from "checkout-query-client/types/form-types";

import { CardPaymentMethod, PlainMessage } from "frontend-client";

export const usePaymentMethodMandate = (paymentType: PaymentType) => {
  const { paymentMethodsList } = useEnabledPaymentMethods();

  return {
    data: (
      paymentMethodsList.find(
        (paymentMethod) => paymentMethod.name === paymentType
      )?.data as PlainMessage<CardPaymentMethod>
    )?.mandate,
  };
};
